import { FeatureFlag, ResolverTag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Input, StarsDropDown, Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';
import { CITY_MAX_LENGTH, useCityFieldValidators } from '@swf/first';
import states from '@swf/generated/states.json';

import {
  TXTCLI_City,
  TXTCLI_Country,
  TXTCLI_Please_enter_ZIP___Postal_Code,
  TXTCLI_State___Province,
  TXTCLI_Zip_Post_Code,
  TXTWCL_Please_contact_Xa_hrefXXcontac_ELL_2
} from './AddressFields.messages.json';

interface Props {
  disabled?: boolean;
  showStates: boolean;
  restricted: boolean;
  children: React.ReactNode;
}

const AddressFields: React.FC<Props> = ({ disabled, showStates, restricted, children }) => {
  const country = useSelector(select.account.getCountry) as string;
  const countryStates = country && states[country];
  const userId = useSelector(select.account.getUserId);
  const email = useSelector(select.account.getEmail);
  const locale = useSelector(select.locale.get);
  const euDeOasisStreetAddress = useFeature(FeatureFlag.EuDeOasisStreetAddress);
  const cityValidators = useCityFieldValidators();

  const cityField = (
    <Input
      id="city"
      label={TXTCLI_City}
      disabled={restricted || disabled}
      maxLength={CITY_MAX_LENGTH}
      validators={cityValidators}
    />
  );

  return (
    <>
      {restricted && (
        <Translation
          values={{
            a: (msg: React.ReactNode) => (
              <ResolverLink
                resolverTag={ResolverTag.AddressChangeSupport}
                query={{ language: locale, userId, email }}
              >
                {msg}
              </ResolverLink>
            )
          }}
          {...TXTWCL_Please_contact_Xa_hrefXXcontac_ELL_2}
        />
      )}
      {children}
      {!euDeOasisStreetAddress && cityField}
      <Input
        id="zip"
        label={TXTCLI_Zip_Post_Code}
        disabled={restricted || disabled}
        validators={[required(TXTCLI_Please_enter_ZIP___Postal_Code)]}
      />
      {euDeOasisStreetAddress && cityField}
      {showStates && countryStates && (
        <StarsDropDown
          id="state"
          label={TXTCLI_State___Province}
          options={countryStates}
          disabled={restricted || disabled}
          validators={[required()]}
        />
      )}
      {showStates && <Input id="country" label={TXTCLI_Country} disabled />}
    </>
  );
};

export default AddressFields;
